import { render, staticRenderFns } from "./PurchasesCreatorList.vue?vue&type=template&id=2dbc8fd4&"
import script from "./PurchasesCreatorList.vue?vue&type=script&lang=ts&"
export * from "./PurchasesCreatorList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports